import { hc } from "hono/client";
import type { PeopleRpc } from "@typedoc/auth/rpc/people";
import { validateApiBase, type RpcFetch } from "./transport";

/**
 * The identity service's people read: who is in the firm, and for owners and admins who is invited
 * and who is asking. Its own router, so this client reaches nothing else the service serves; the
 * changes to people (roles, removal, invitations) are clients of their own.
 */
export function createPeopleClient(base: string, fetcher?: RpcFetch) {
  return hc<PeopleRpc>(validateApiBase(base), {
    ...(fetcher ? { fetch: fetcher } : {}),
    init: { credentials: "include" },
    headers: { Accept: "application/json" },
  });
}

export type PeopleClient = ReturnType<typeof createPeopleClient>;
